import { AlignItems, FlexDirection, JustifyContent } from '@/src/components/c-flex/CFlex';

export enum CTableSortDirection {
  Asc = 'asc',
  Desc = 'desc',
}


export interface CTableRow {
  id: string;
}

export interface CTableHeaderSort {
  key: string;
  direction?: CTableSortDirection;
}

export interface CTableSort {
  key: string;
  direction: CTableSortDirection;
}

export interface CTablePagination {
  size: number;
  total: number;
  page: number;
}

export interface CTableQuery {
  pagination?: CTablePagination;
  sort: CTableSort[];
}

export interface CTableColumnCell<TDto extends CTableRow> {
  title: string;
  sort?: CTableHeaderSort;
  justifyContent?: JustifyContent,
  alignItems?: AlignItems,
  direction?: FlexDirection,
  component: (dto: TDto) => React.JSX.Element;
}

export interface CTableColumn<TDto extends CTableRow> {
  size?: string;
  header?: boolean;
  cells: CTableColumnCell<TDto>[];
}

export interface CTableConfiguration<TDto extends CTableRow> {
  label: string;
  items: TDto[];
  columns: CTableColumn<TDto>[];
  selectedIds?: string[];
  onSelect?: (ids: string[]) => (Promise<void> | void);
  onSort?: (sort: CTableSort[]) => (Promise<void> | void);
  onPagination?: (pagination: CTablePagination) => (Promise<void> | void);
  pagination?: CTablePagination;
  translations: {
    summary: (current: number, total: number) => string;
  }
}